import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { ifDefined as l } from '../../../../node_modules/lit-html/directives/if-defined.js';
import { unsafeHTML as o } from '../../../../node_modules/lit-html/directives/unsafe-html.js';
import css_248z from './generic-image.scss.js';
import { RATIO_CLASS } from './generic-image.types.js';

class GenericImage extends s {
    constructor() {
        super(...arguments);
        this.src = '';
        this.alt = '';
        this.aspectRatio = null;
        this.caption = '';
        this.decorative = '';
        this.href = null;
        this.target = null;
        this.loading = 'lazy';
        this.fetchpriority = 'auto';
        this.class = null;
    }
    get ratioClass() {
        var _a;
        if (!this.aspectRatio)
            return '';
        return (_a = RATIO_CLASS[this.aspectRatio]) !== null && _a !== void 0 ? _a : '';
    }
    onKeyActivate(e) {
        var _a;
        if (!this.href)
            return;
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            const a = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('a.interactive');
            a === null || a === void 0 ? void 0 : a.click();
            this.dispatchEvent(new CustomEvent('image-activate', { bubbles: true, composed: true }));
        }
    }
    renderImg() {
        const isDecorative = this.decorative === 'decorative';
        const altText = isDecorative ? '' : this.alt;
        const roleValue = isDecorative ? 'presentation' : undefined;
        const ariaHidden = isDecorative ? 'true' : undefined;
        return $ `<img class="media" src="${this.src}" alt="${altText}" role="${l(roleValue)}" aria-hidden="${l(ariaHidden)}" loading="${this.loading}" fetchpriority="${this.fetchpriority}" decoding="async" draggable="false">`;
    }
    renderImageNode() {
        if (this.href) {
            return $ `<a class="interactive" href="${this.href}" target="${l(this.target || undefined)}" rel="${l(this.target === '_blank' ? 'noopener noreferrer' : undefined)}" @keydown="${this.onKeyActivate}">${this.renderImg()}</a>`;
        }
        return this.renderImg();
    }
    renderWrapper(content) {
        const rc = this.ratioClass;
        return $ `<div class="wrapper ${rc}">${content}</div>`;
    }
    renderFigureWithCaption() {
        const imgClasses = this.class ? this.class : '';
        return $ `<figure class="${imgClasses}">${this.renderWrapper(this.renderImageNode())}<figcaption>${o(this.caption)}</figcaption></figure>`;
    }
    renderDiv() {
        const imgClasses = this.class ? this.class : '';
        return $ `<div class="${imgClasses}">${this.renderWrapper(this.renderImageNode())}</div>`;
    }
    render() {
        var _a;
        const hasCaption = ((_a = this.caption) === null || _a === void 0 ? void 0 : _a.trim().length) > 0;
        const isDecorative = this.decorative === 'decorative';
        if (isDecorative)
            return this.renderDiv();
        if (hasCaption)
            return this.renderFigureWithCaption();
        return this.renderDiv();
    }
}
GenericImage.styles = css_248z;
__decorate([
    e({ type: String })
], GenericImage.prototype, "src", void 0);
__decorate([
    e({ type: String })
], GenericImage.prototype, "alt", void 0);
__decorate([
    e({ type: String, attribute: 'aspect-ratio' })
], GenericImage.prototype, "aspectRatio", void 0);
__decorate([
    e({ type: String })
], GenericImage.prototype, "caption", void 0);
__decorate([
    e({ type: String })
], GenericImage.prototype, "decorative", void 0);
__decorate([
    e({ type: String })
], GenericImage.prototype, "href", void 0);
__decorate([
    e({ type: String })
], GenericImage.prototype, "target", void 0);
__decorate([
    e({ type: String })
], GenericImage.prototype, "loading", void 0);
__decorate([
    e({ type: String })
], GenericImage.prototype, "fetchpriority", void 0);
__decorate([
    e({ type: String })
], GenericImage.prototype, "class", void 0);
customElements.define('generic-image', GenericImage);

export { GenericImage };
